<div class="text-primary">
    <p>
        Sembra che qualcosa non abbia funzionato come previsto...<br>
        Riprova un'altra volta; se trovi ancora difficoltà, contatta il servizio di assistenza: <em class="text-info">supporto&#64;winowino.it</em>
    </p>
    <p class="text-primary" *ngIf="errorMessage">Messaggio di errore: <strong>{{errorMessage}}</strong></p>
</div>